import { call, put, select, takeEvery } from 'redux-saga/effects';
import { types } from '@actions/attendees';
import { sendTranscriptCompletionEmailToAttendee } from '@services/attendeeResourse';
import { tokenSelector } from '@selectors/authentication';
import { selectTranscriptIdsFromRecordings } from '@selectors/conference';

export function* requestTranscriptCompletionEmail({ transcriptId, attendeeId }) {
  try {
    const token = yield select(tokenSelector);
    // transcriptId will be defined if action comes from transcript dashboard
    // we select transcriptIds from conference if action comes from conference view page
    const transcriptIds = transcriptId
      ? [transcriptId]
      : yield select(selectTranscriptIdsFromRecordings);
    yield call(sendTranscriptCompletionEmailToAttendee, {
      transcriptIds,
      attendeeId,
      token,
    });
    yield put({
      type: types.REQUEST_TRANSCRIPT_COMPLETION_EMAIL.SUCCESS,
    });
  } catch (err) {
    yield put({
      type: types.REQUEST_TRANSCRIPT_COMPLETION_EMAIL.FAILURE,
      message: err.message || 'Error when requesting completion email',
      errors: err.errors,
    });
  }
}

export default function* attendeesSaga() {
  yield takeEvery(
    types.REQUEST_TRANSCRIPT_COMPLETION_EMAIL.STARTED,
    requestTranscriptCompletionEmail,
  );
}



// WEBPACK FOOTER //
// ./redux/sagas/attendees.js